import apiTools from './apiTools';
import type { QueueStatus } from '@vidende/contracts';

// Queue payload types now live in @vidende/contracts; re-exported here for
// backward compatibility with existing Client importers of this module.
export type {
    QueueStatus,
    QueueActionType,
    QueueItem,
    ProcessingError,
} from '@vidende/contracts';

class QueueApi {
    static getQueueStatus(queueId): QueueStatus {
        return apiTools
            .get(`Queues/${queueId}/queueStatus`)
            .then((response: { data: QueueStatus }) => {
                return response.data;
            });
    }

    static getQueueItems(filter: any) {
        return apiTools.get(`Queues`, { filter }).then((response) => {
            return response.data;
        });
    }

    static getQueueSummary() {
        return apiTools.get(`Queues/getQueueSummary`).then((response) => {
            return response.data;
        });
    }
}

export default QueueApi;
